import { getDepositInfo } from '@t7x000/apex-web/lib/redux/actions/depositActions.js';

export const depositMiddleware = (store) => (next) => (action) => {
  if (
    action.type === 'RECEIVE_DEPOSIT_TEMPLATE' &&
    (action.payload?.Template?.DepositWorkflow === 'CryptoWallet' || action.payload?.Template?.UseGetDepositWorkflow)
  ) {
    const productId = store.getState().deposit.product;
    if (productId) {
      store.dispatch(getDepositInfo(productId));
    }
  }

  return next(action);
};

export default depositMiddleware;
